import type { PropsWithChildren } from 'react'
import { Content } from './Content'
import { Header } from './Header'
import type { CollapsibleProviderProps } from './useCollapsible.constate'
import { CollapsibleProvider } from './useCollapsible.constate'

export type CollapsibleProps = PropsWithChildren<CollapsibleProviderProps>

export function Collapsible(props: CollapsibleProps) {
  const { children, ...providerProps } = props

  return (
    <CollapsibleProvider {...providerProps}>{children}</CollapsibleProvider>
  )
}

Collapsible.Header = Header
Collapsible.Content = Content
